var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!this.$route.params.portalUuid)?_c('cbr-header',{class:_vm.$style.mask},[_c('cbr-logo',{attrs:{"slot":"logo","src":'/assets/gls_logo.png',"position":"left"},slot:"logo"})],1):_vm._e(),_vm._v(" "),_c('cbr-solo-map',{class:_vm.$style.mapClass,attrs:{"show":true}}),_vm._v(" "),_c('cbr-footer',{class:_vm.$style.footerClass})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5039c516","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/MapHolder.vue
// module id = 233
// module chunks = 0